<template>
<div class="site-header" style="padding:0 10px;">
   <!--mobile -->
   
   <div class="row yo-text-normal" v-if="$teras.app.device!='desktop'">
      <div class="col s10"><!-- LIMMSY - Limmsy is Member Management System -->&#160;</div>
      <div class="col s2"><a class="button" v-on:click="$teras.event.emit('sidebarToggle')" v-if="$teras.app.auth"><i class="material-icons">menu</i></a></div>
      <!-- <div style="background:red;width:10px;height:40px;"></div> -->
   </div>


  <!-- desktop -->
   <div class="row vpad container yo-text-normal" v-if="$teras.app.device=='desktop'" >
      <div class="col s8 yo-align-left"><!-- LIMMSY - Limmsy is Member Management System -->&#160;</div>
      <div class="col s4">
         <div class="row yo-text-small" v-if="$teras.app.auth">
            <div class="col s2m"><router-link to="/home">HOME</router-link></div>
            <!--
            <div class="col s3m"><router-link to="/loadpage/info/congressi-precedenti">PRECEDENTI</router-link></div>
            -->
            <div class="col s5"><a href="http://www.neurologiapediatrica.it/" target="blank">WEBSITE</a></div>
            <div class="col s3m"><a @click.prevent="$teras.event.emit('logout')" href="#" >ESCI</a></div>
         </div>
      </div>
   </div>

   
</div>
</template>

<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
#app.device-tablet .site-header{
   
}
.site-header{
   height:40px;
   overflow:hidden;
   background: #004680;
   border-bottom:1px solid grey;
   color:#ffffff;
}.site-header > .row > div{
   line-height:40px;    
}.site-header a{
   color:#ffffff;
   display:block;
   text-align:center;
}.site-header a:first{
   border-left:none !important;
}.site-header a.button i, .footer-bottom a.button i{
    line-height: 40px;
    height: 40px;
    font-size: 3.2rem;
    color:#fff;
}
</style>
